import type { HttpService } from '@storebrand-digital/bank-foundation-http-service';

import ApiRoutePath from '../constants/apiRoutePath';
import type { GetCustomerContactInfoResponse } from '../types';

export default class CommonService {
  #httpService: HttpService;

  constructor(httpService: HttpService) {
    this.#httpService = httpService;
  }

  getCustomerContactInformation = async () =>
    this.#httpService
      .get<GetCustomerContactInfoResponse>(
        ApiRoutePath.GET_CUSTOMER_CONTACT_INFO
      )
      .then(({ data }) => data);
}
